import { AxiosResponse } from 'axios'
import ErrorCode from './ErrorCodes'
import handleValidationError from './handleValidationError'
import validateMessage from './validateMessage'

const handleResponseError = (res: AxiosResponse) => {
  const { code, payload } = res.data
  switch (code) {
    case ErrorCode.VALIDATION_ERRORS:
      if (payload?.errors) {
        return handleValidationError(res)
        // return errors.map(err => `error:${err}`).join('\n')
      }
      return validateMessage.serverError
    default:
      return ErrorCode[code]
  }
}

export default handleResponseError
